// LO QUE EL SELECTOR DE UBICACIÓN DECIDE SIN PANTALLA · CATÁLOGO VIVO F3.
//
// Funciones puras: qué se le pide al servidor, cómo se pinta una ruta y qué
// botón se ofrece en cada fila. Viven aparte para probarlas sin montar nada.

export const RUTA = '/catalogo-vivo/ubicaciones';
export const SEPARADOR = ' > ';
// Lo que se espera entre teclas antes de buscar: lo bastante para no pedir
// una búsqueda por letra, lo bastante poco para que se sienta inmediato.
export const ESPERA_BUSQUEDA_MS = 250;

/** La URL de `GET /selector` con solo los parámetros que traen algo. */
export function urlDelSelector({ q, padre, idCategoria, idProducto } = {}) {
  const p = new URLSearchParams();
  const texto = (q || '').trim();
  if (texto) p.set('q', texto);
  if (padre != null) p.set('padre', String(padre));
  if (idCategoria != null) p.set('id_categoria', String(idCategoria));
  if (idProducto != null) p.set('id_producto', String(idProducto));
  const s = p.toString();
  return `${RUTA}/selector${s ? `?${s}` : ''}`;
}

/** «Habitación > Mesa de trabajo > Caja» desde lo que manda el servidor. */
export function rutaLegible(u) {
  if (!u) return '';
  if (u.ruta_texto) return u.ruta_texto;
  return (u.ruta_nombres || [u.nombre]).join(SEPARADOR);
}

/**
 * Las migas de pan del nivel actual: «Inicio» y luego un paso por ancestro.
 * Cada miga lleva el `padre` al que vuelve (null = las raíces).
 */
export function migas(actual) {
  const pasos = [{ etiqueta: 'Inicio', padre: null }];
  if (!actual) return pasos;
  const nombres = actual.ruta_nombres || [actual.nombre];
  const ids = actual.ruta_ids || [actual.id];
  nombres.forEach((n, i) => pasos.push({ etiqueta: n, padre: ids[i] }));
  return pasos;
}

/**
 * Qué hace tocar una fila.
 *   · 'entrar'  — tiene lugares dentro: se navega (y si además se puede
 *                 elegir, la fila ofrece «Elegir» aparte).
 *   · 'elegir'  — es una hoja que se puede elegir.
 *   · 'nada'    — hoja que no se puede elegir: se ve apagada con su motivo.
 */
export function accionDeFila(u) {
  if (u.hijos > 0) return 'entrar';
  return u.elegible ? 'elegir' : 'nada';
}

/** El texto de la sugerida, en una línea: de quién es y para qué. */
export function textoSugerida(s, nombreCategoria) {
  if (!s) return '';
  const para = nombreCategoria ? ` para ${nombreCategoria}` : ' para esta categoría';
  return s.de_quien === 'tuya'
    ? `La última que usaste${para}`
    : `La última que usó tu empresa${para}`;
}

// Los tipos que se ofrecen al crear al vuelo. No son todos los del catálogo:
// los virtuales (tránsito, cliente, merma…) no se crean desde una ficha.
export const TIPOS_AL_VUELO = [
  ['ESTANTE', 'Estante o repisa'],
  ['GAVETA', 'Gaveta, caja o cajón'],
  ['ZONA', 'Zona o cuarto'],
  ['RACK', 'Rack'],
  ['NIVEL', 'Nivel de un rack'],
  ['VITRINA', 'Vitrina'],
  ['PASILLO', 'Pasillo'],
  ['BODEGA', 'Bodega'],
  ['TALLER', 'Taller'],
];
